// import { LanguageType } from 'store/reducers/locale/langugeType'
// export const environment = {
//    firebase: {
//     apiKey: 'AIzaSyAuvWeik_adu_EVqLSGQIezW7erT2YU0mk',
//     authDomain: 'hullthread-test.firebaseapp.com',
//     databaseURL: 'https://hullthread-test.firebaseio.com',
//     projectId: 'hullthread-test',
//     storageBucket: 'hullthread-test.appspot.com',
//     messagingSenderId: '294012382591',
//     appId: '1:294012382591:web:daaedaff6766cbfb'
//   },
//   stripe: {
//     apiKey: 'pk_test_uIwvwJKZtt2uwRSAo96KDMx5'
//   },
//   settings: {
//     enabledOAuthLogin: true,
//     appName: 'Hullthread Test',
//     defaultProfileCover: 'https://firebasestorage.googleapis.com/v0/b/dcomptest-19523.appspot.com/o/defaultBack%2Frain.jpg?alt=media&token=677e6163-db36-45cc-bee6-910cf0a1633a',
//     defaultLanguage: LanguageType.English
//   },
//   theme: {
//     primaryColor: '#d0ac74',      // follow button color
//     secondaryColor: '#33383b',     // header color
//     tertiaryColor: '#yellow'
//   }
// }
// HullThread actual credentials
import { LanguageType } from 'store/reducers/locale/langugeType';
export var environment = {
    firebase: {
        apiKey: 'AIzaSyCiQDAsqqX1O-9zmnD8xp8QHgJjATNkaOc',
        authDomain: 'hullthread.firebaseapp.com',
        databaseURL: 'https://hullthread.firebaseio.com',
        projectId: 'hullthread',
        storageBucket: 'hullthread.appspot.com',
        messagingSenderId: '859355185485'
    },
    stripe: {
        apiKey: 'pk_live_D07HlPhslhVq2EdCmzd6oypm'
    },
    settings: {
        enabledOAuthLogin: true,
        appName: 'HullThread',
        defaultProfileCover: 'https://media.giphy.com/media/f4pMuyoZwE5QQ/giphy.gif',
        defaultLanguage: LanguageType.English
    },
    theme: {
        primaryColor: '#d0ac74',
        secondaryColor: '#33383b',
        tertiaryColor: '#yellow'
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/config/environment.prod.ts
// module id = 489
// module chunks = 50